export default __webpack_public_path__ + "static/media/taxi_2.66438947.png";